import { useState } from "react";
import { ToolboxComponentDropdown as Dropdown } from "PosterEditor/sidebar/toolboxes/toolbox-components/toolbox-component-dropdown";
import styles from "./size-preset-dropdown-menu.module.css";
import { SizePreset } from "PosterEditor/model/size-presets/size-preset";
import { filterClasses } from "PosterEditor/utils/filter-classes";
import { useIsMobile } from "hooks/useIsMobile";

interface Props {
  sizePresets: SizePreset[];
  selectedPreset: SizePreset | undefined;
  onSelectPreset: (preset: SizePreset) => void;
  disabled?: boolean;
}

export const SizePresetDropdownMenu = ({
  sizePresets,
  selectedPreset,
  onSelectPreset,
  disabled,
}: Props) => {
  const [isVisible, setIsVisible] = useState(false);
  const isMobile = useIsMobile(768);

  const handleSelectPreset = (preset: SizePreset) => {
    onSelectPreset(preset);
    setIsVisible(false);
  };

  const Label = () => {
    return (
      <div
        className={filterClasses(
          styles.sizePresetLabel,
          disabled ? styles.disabled : ""
        )}
      >
        <span className={styles.labelText}>
          {selectedPreset?.sizeDescription ?? "Select Size"}
        </span>
        <img
          className={styles.expandChevron}
          src={
            !isVisible
              ? "/pallete-components/CHEVRON-DOWN-ICON.svg"
              : "/pallete-components/CHEVRON-UP-ICON.svg"
          }
          alt="Expand size presets"
        />
      </div>
    );
  };

  return (
    <div className={styles.wrapper}>
      <Dropdown
        isVisible={isVisible}
        onToggleVisibility={() => setIsVisible((prev) => !prev)}
        label={<Label />}
        dropUp={isMobile}
      >
        <div className={styles.sizePresetContainer}>
          {sizePresets.map((preset) => (
            <button
              key={preset.id}
              className={filterClasses(
                styles.presetOption,
                selectedPreset?.id === preset.id
                  ? styles.presetOptionSelected
                  : ""
              )}
              onClick={() => handleSelectPreset(preset)}
            >
              <div className={styles.presetContent}>
                <span className={styles.presetDescription}>
                  {preset.sizeDescription}
                </span>
                {preset.priceInt && (
                  <span className={styles.presetPrice}>
                    £{(preset.priceInt / 100).toFixed(2)}
                  </span>
                )}
              </div>
            </button>
          ))}
        </div>
      </Dropdown>
    </div>
  );
};
